import axios from "./axios";

class StaffReportsAPI {
  getDetails(code) {
    return axios.get(`api/staffreport/${code}`);
  }
}

const Reports = new StaffReportsAPI();

export default Reports;
